import React, { useContext, useState } from 'react';
import parse from 'html-react-parser';
import TextField from '@material-ui/core/TextField';
import CloseIcon from '@material-ui/icons/Close';
import DoneIcon from '@material-ui/icons/Done';
import { ActionIcon } from '@mummssoftware/common-ui';
import { emptyText, ProgressNotes } from '@mummssoftware/utils/constants';
import {
  GlobalContext,
  CLOSE_WIDGET,
} from '@mummssoftware/global-context/GlobalContext';
import { Context } from '../../context';
import {
  NoteContentDiv,
  SubmitPNDiv,
  SubmitTextDiv,
  SubmitButtonsDiv,
  TextAreaWrapper,
  TextAreaGroup,
} from '../../components/layout/WrapperDiv';
import { useStyles } from '../style/style';
import defaults from '../../translations/en.json';

/**
 * Orders Log addendum mode: read-only order text + editable additional info.
 * Save PUT-appends via saveOrderAddendum.
 */
const OrderAddendum = () => {
  const { appendOrder, saveOrderAddendum, readOnly } = useContext(Context);
  const { dispatch } = useContext(GlobalContext);
  const [additionalText, setAdditionalText] = useState(emptyText);
  const [saving, setSaving] = useState(false);
  const classes = useStyles();

  if (!appendOrder) {
    return null;
  }

  const canSave =
    !readOnly &&
    !saving &&
    !!additionalText &&
    additionalText.trim() !== emptyText &&
    !!saveOrderAddendum;

  const handleClose = () => {
    if (dispatch) {
      dispatch({
        type: CLOSE_WIDGET,
        payload: { componentName: ProgressNotes },
      });
    }
  };

  const handleSave = async () => {
    if (!canSave || !saveOrderAddendum) {
      return;
    }
    setSaving(true);
    try {
      await saveOrderAddendum(additionalText.trim());
    } finally {
      setSaving(false);
    }
  };

  const iconStyle = {
    margin: 0,
    width: 20,
    height: 20,
  };

  return (
    <TextAreaWrapper>
      <TextAreaGroup style={{ justifyContent: 'flex-start' }}>
        <NoteContentDiv style={{ marginBottom: '2em' }}>
          {parse(appendOrder.orderNoteText || '')}
        </NoteContentDiv>
        <TextField
          id="order-addendum-text"
          name="orderAddendum"
          placeholder={defaults.orderAddendumPlaceholder}
          minRows={3}
          maxRows={90}
          disabled={!!readOnly || saving}
          onChange={(event) => setAdditionalText(event.target.value)}
          value={additionalText}
          variant="outlined"
          multiline
          fullWidth
          InputProps={{
            classes: {
              input: classes.inputFieldHeight,
              root: classes.orderNoteField,
            },
          }}
          classes={{
            root: classes.orderNoteField,
          }}
        />
        <SubmitPNDiv style={{ marginTop: 8, alignSelf: 'flex-end' }}>
          <SubmitTextDiv style={{ whiteSpace: 'nowrap', alignItems: 'center' }}>
            {defaults.saveAddendum}
          </SubmitTextDiv>
          <SubmitButtonsDiv>
            <ActionIcon
              style={iconStyle}
              Icon={DoneIcon}
              onClick={handleSave}
              htmlColor={canSave ? 'black' : 'grey'}
              disabled={!canSave}
            />
            <ActionIcon
              style={iconStyle}
              Icon={CloseIcon}
              onClick={handleClose}
              htmlColor={saving ? 'grey' : 'black'}
              disabled={saving}
            />
          </SubmitButtonsDiv>
        </SubmitPNDiv>
      </TextAreaGroup>
    </TextAreaWrapper>
  );
};

export default OrderAddendum;
